'use client';

import type { SupportData } from '@/data/types';

interface SupportViewProps {
  supportData: SupportData;
  onSelectMember: (id: string) => void;
  onShowToast: (message: string) => void;
}

export default function SupportView({
  supportData,
  onSelectMember,
  onShowToast,
}: SupportViewProps) {
  return (
    <div className="dashboard-view active">
      <h2 className="dash-heading">Support &amp; Re-Engagement</h2>
      <p className="dash-subtext">
        Open tickets, sentiment flags, and members who have gone quiet.
      </p>
      <div>
        {/* Tickets */}
        {supportData.tickets.map((t, i) => (
          <div key={i} className="support-card">
            <div className="support-card-header">
              <span
                className="slack-member-name"
                style={{ cursor: 'pointer' }}
                onClick={() => onSelectMember(t.memberId)}
              >
                {t.member}
              </span>
              <span className="support-status open">
                Open &mdash; {t.daysSince} days
              </span>
            </div>
            <div className="opp-title" style={{ marginBottom: 8 }}>
              {t.subject}
            </div>
            <div className="opp-narrative">{t.summary}</div>
            <div style={{ marginBottom: 12 }}>
              <span style={{ fontSize: '0.75rem', color: 'var(--cream-faint)' }}>
                Sentiment:
              </span>{' '}
              <span style={{ fontSize: '0.78rem', color: 'var(--amber)' }}>
                {t.sentiment}
              </span>
            </div>
            <div className="opp-actions">
              <button
                className="opp-btn primary"
                onClick={() => onShowToast(`Reply drafted for ${t.member}`)}
              >
                Draft Reply
              </button>
              <button
                className="opp-btn secondary"
                onClick={() => onShowToast('Ticket opened')}
              >
                View Full Ticket
              </button>
            </div>
          </div>
        ))}

        {/* Quiet Members */}
        <div className="quiet-members-section">
          <div
            className="section-label"
            style={{ padding: '0 0 12px', color: 'var(--red-soft)' }}
          >
            Quiet Members — Re-Engagement Needed
          </div>
          {supportData.quietMembers.map((q, i) => (
            <div
              key={i}
              className="quiet-member-row"
              onClick={() => onSelectMember(q.id)}
            >
              <div className="quiet-avatar">{q.initials}</div>
              <div className="quiet-info">
                <div className="quiet-name">{q.name}</div>
                <div className="quiet-detail">{q.detail}</div>
              </div>
              <div className="quiet-days">Last seen {q.lastSeen}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
